
import Vue from "vue";
export default Vue.extend({
  props: {
    value: String,
    max: Number,
  },
  data() {
    return {
      v: "",
    };
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.v = this.value;
      },
    },
  },
  methods: {
    focus(){
      (this.$el as HTMLInputElement).focus();
      // (this.$el as HTMLInputElement).selectionStart = 0;
      // (this.$el as HTMLInputElement).selectionEnd = this.v.length-1;
    },
    onFocus() {
      //this.v = this.v.replace(/0([0-9]+)$/, "$1");
    },
    onBlur(e: FocusEvent) {

      this.v = this.v.replace(/^0+/, "").padStart(2, "0");
      this.$emit("input", this.v);
    },

    onKeydown(e: KeyboardEvent) {
      if (!this.isKeyAllowed(e.key, e.keyCode)) {
        e.preventDefault();
      }

      if (e.keyCode == 38) {
        let v = parseInt(this.v) + 1;
        if (v > this.max) {
          v = 0;
        }
        this.$emit("input", v.toString().padStart(2, "0"));
      }
      if (e.keyCode == 40) {
        let v = parseInt(this.v) - 1;
        if (v < 0) {
          v = this.max;
        }
        this.$emit("input", v.toString().padStart(2, "0"));
      }

      if (e.keyCode == 37 && (this.$el as HTMLInputElement).selectionStart == 0){
        this.$emit("left");
      }
      if (e.keyCode == 39 && (this.$el as HTMLInputElement).selectionStart == this.v.length){
        this.$emit("right");
      }
    },

    isKeyAllowed(key: string, keyCode: number): boolean {
      return (
        ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(key) ||
        keyCode == 8 || // bs
        keyCode == 9 || // tab
        keyCode == 13 || // enter
        keyCode == 46 || // del
        keyCode == 37 || // left
        keyCode == 39 // right
      );
    },
  },
});
